export default __webpack_public_path__ + "static/media/main-logo.831c757b.png";